import cn from "@utils/helpers/cn";

export default function contentWidthClassNames(size = "md") {
  return cn("mx-auto w-full", {
    "md:w-16/24 lg:w-12/24 xl:w-8/24": size === "xxs",
    "md:w-20/24 lg:w-12/24 xl:w-10/24": size === "xs",
    "md:w-20/24 lg:w-16/24 xl:w-12/24": size === "sm",
    "md:w-20/24 lg:w-20/24 xl:w-16/24": size === "md",
    "md:w-20/24 lg:w-20/24 xl:w-20/24": size === "lg",
  });
}
